import Vue from 'vue'
import * as types from './mutation-types'

export default {
  [types.SET_PAGE_TITLE] ({ state, commit }, title) {
    if (title) {
      document.title = `${state.appName} - ${title}`
    } else {
      document.title = `${state.appName}`
    }
    commit(types.SET_PAGE_TITLE, title)
  },
  async cred2token ({ commit }, credential) {
    let response = await Vue.http.post('/api/admin/token', credential)
    commit(types.SET_TOKEN, response.body.accessToken)
  },
  async token2user ({ commit }) {
    let response = await Vue.http.get('/api/admin/users/me')
    commit(types.SET_USER, response.body)
  },
  async login ({ dispatch }, credential) {
    await dispatch('cred2token', credential)
    await dispatch('token2user')
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js